import { render } from "./BubblebitPage.vue?vue&type=template&id=18aff374&scoped=true"
import script from "./BubblebitPage.vue?vue&type=script&lang=js"
export * from "./BubblebitPage.vue?vue&type=script&lang=js"

import "./BubblebitPage.vue?vue&type=style&index=0&id=18aff374&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18aff374"]])

export default __exports__